export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8615.d38e3069.jpg";